import '../styles/HeaderHomeOut.css'

const HeadHomeOut = (props) => {

    const downloadCondicionesGenerales = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = props.pdfCondiciones
        // downloadLink.download = "Condiciones Generales.pdf"
        downloadLink.download = "Guía rápida.pdf"
        downloadLink.click()
    }

    /*const downloadCondicionesGeneralesMobile = () => {
        const downloadLink = document.createElement("a");
        downloadLink.href = "data:application/octet-stream;base64," + props.pdfCondiciones.split(",")[1]
        console.log(downloadLink.href);
        downloadLink.download = "Condiciones Generales.pdf"
        downloadLink.click()   
    }*/

    const downloadCondicionesGeneralesMobile = () => {
        const base64String = props.pdfCondiciones.split(',')[1] // Replace with your actual Base64 string
        const byteCharacters = atob(base64String)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], { type: 'application/pdf' })
        const fileUrl = URL.createObjectURL(fileBlob)
        const link = document.createElement('a')
        link.href = fileUrl
        // link.download = 'Condiciones Generales.pdf' // Replace with the desired filename
        link.download = 'Guía rápida.pdf' // Replace with the desired filename

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        //window.open(fileUrl);
        URL.revokeObjectURL(fileUrl)
    }

    return (
        <>
            <div className="container-fluid banner pe-0 ps-0 d-block d-lg-none">
                {/* <div className="container-xxl pe-0 ps-0"> */}
                    <div className="row me-0">
                        <div className="col-12 col-md-6 pt-lg-4 pe-0">
                            <img src='/assets/img/homeout/CPC-logonuevo 1.png' alt='logo_proteccion_celular' className="banner__logo"/>
                            <img src='/assets/img/homeout/img-banner-homeoutheader.png' className="banner__image d-block d-md-none" alt='' />
                            <div className="banner__text__center">
                                <h5 className="banner__title text-center"><b>¡Bienvenido!</b></h5>
                                <p className="banner__text pe-3 mt-3 pb-3 text-center">Conozcamos juntos todo lo relacionado con tu Seguro Club de Protección Celular</p>
                                <div className="div__botones">
                                    <button className="btn__azul" onClick={downloadCondicionesGeneralesMobile}>Descargar guía rápida</button>
                                </div>              
                            </div>

                            <div className="row banner__footer align-items-center d-flex d-md-none" style={{'fontSize':'1.3rem'}}>
                                <div className="col-6 ps-5 banner__footer__text">
                                    <p>Llama sin costo <span><a href='tel:800 953 0424'>800 953 0424</a></span></p>
                                    <p>Horarios de atención:</p>
                                    <p>Lun a dom de 09:00 a 21:00 hrs.</p>
                                </div>
                                <div className="col-6 text-center">
                                    <p><a href='mailto:sac_mx@cardif.com.mx'>sac_mx@cardif.com.mx</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 d-none d-md-block pe-lg-0">
                            <img src='/assets/img/homeout/img-banner-homeoutheader.png' className="banner__image" alt='' />
                        </div>
                    </div>

                    <div className="row banner__footer d-none d-md-flex ms-0 me-0">
                        <div className="col-12">
                            <div className="row align-items-center">
                                <div className="col-9 ps-5 banner__footer__text">
                                    <p className="">Llama sin costo <span className="ps-3 pe-3"><b><a href='tel:800 953 0424'>800 953 0424</a></b></span></p>
                                    <p className="pe-3">Horarios de atención: Lunes a domingo de 09:00 a 21:00 hrs.</p>
                                    <p></p>
                                    <p></p>
                                </div>
                                <div className="col-3 text-center">
                                    <p>sac_mx@cardif.com.mx</p>
                                </div>
                            </div>
                        </div>
                    </div>
                {/* </div> */}
            </div>
            <div className='home p-0 d-none d-lg-block'> 
                <div className='container-cookie bannerInicial'>
                    <div className='row bannerI'>
                        <div className='col-12 col-md-6 col-back'>
                            <img style={{ paddingLeft: '6rem' }} src='/assets/img/homeout/CPC-logonuevo 1.png' alt='logo_proteccion_celular' className='mt-5 banner__logo'/>
                            <div className='home__text-container'>
                                <div className='home__title mb-5'>
                                    <h2>¡Bienvenido!</h2>
                                </div>

                                <div className='home__text mb-5' style={{ marginRight: '15rem' }}>
                                    <p className='mb-0'><b>Conozcamos juntos todo lo relacionado con tu seguro Club de Protección Celular</b></p>
                                </div>
                                <button className='btn__azul' style={{ width: '53%' }} onClick={downloadCondicionesGenerales}>DESCARGAR GUÍA RÁPIDA</button>
                            </div>
                        </div>

                        <div className='col-12 col-md-6 col-image p-0'>
                            <div className='home__image-container'>
                                <img src='/assets/img/homeout/img-banner-homeoutheader.png' className="home__image_desks" alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='head__footer d-none d-lg-block'>
                <p>Llama sin costo: <b style={{ marginLeft: '1.5rem' }}><a href='tel:800 953 0424'>800 953 0424</a></b><img style={{ height:"33px", marginRight: "15px", marginLeft: "15px" }} src='/assets/img/common/line.png' alt='linea_blanca' /> Horarios de atención: Lunes a domingo de 09:00 a 21:00 hrs.
                    <img style={{ height:"33px", marginRight: "15px", marginLeft: "15px" }} src='/assets/img/common/line.png' alt='linea_blanca' /> <a href='mailto:sac_mx@cardif.com.mx'>sac_mx@cardif.com.mx</a>
                </p>
            </div>
        </>
    )
}

export default HeadHomeOut